// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dl-breadcrumb[data-v-0727fd70] {\n  height: 40px;\n  line-height: 40px;\n}\n", ""]);
// Exports
module.exports = exports;
